import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from './models'
import { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /** @see {@link State.Focused.discard} */
    discardFocused: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducerDeprecated: state => State.Focused.discard(state),
    }),
    /** @see {@link State.Lookup.set} */
    putInitialDefinitions: store.actions.standalone({
      data: store.actions.Data.asIs<models.Definition.List>(),
      reducerDeprecated: (state, data) => State.Lookup.set(state, data),
    }),
    /** @see {@link State.Lookup.remove} */
    removeDefinition: store.actions.standalone({
      data: store.actions.Data.asIs<models.Definition['id']>(),
      reducerDeprecated: (state, data) => State.Lookup.remove(state, data),
    }),
    /** @see {@link State.reset} */
    reset: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducerDeprecated: state => State.reset(state),
    }),
    /** @see {@link State.Focused.save} */
    saveFocused: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducerDeprecated: state => State.Focused.save(state),
    }),
    /** @see {@link State.Focused.set} */
    setFocused: store.actions.standalone({
      data: store.actions.Data.asIs<State.Focused.set.Request>(),
      reducerDeprecated: (state, data) => State.Focused.set(state, data),
    }),
    /** @see {@link State.Focused.update} */
    updateFocused: store.actions.standalone({
      data: store.actions.Data.asIs<State.Focused.update.Request>(),
      reducerDeprecated: (state, callback) =>
        State.Focused.update(state, callback),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
